<template>
  <div class="card shadow">
    <div class="card-header">
      <p class="label mar-bot-10">SEDANG BERLANGSUNG</p>
      <b class="header-text">{{ format(whitelabel[0].whitelabel_jenis_id) }}</b>
      <br />
      <b class="price-text">RP {{ formatRupiah(whitelabel[0].tagihan) }}</b>
      <p class="sub-info remove-margin">
        Dapat dicicil selama 6x dalam 6 bulan
      </p>
    </div>
    <div class="card-body">
      <div class="content-1">
        <p>
          Periode pemesanan: <br />
          November - Desember 2023
        </p>
      </div>
      <div class="content-2">
        <b> Benefit </b>
        <ul>
          <li>
            Aplikasi multi platform yang sudah terintegrasi dengan akun
            Smartlink anda
          </li>
          <li>Dapat menerima 300 transaksi per hari</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { moduleName } from "../store/state";

export default {
  name: "CardWhitelabel",
  async mounted() {
    await this.init();
  },
  computed: {
    ...mapGetters(moduleName, {
      whitelabel: "whitelabel",
    }),
  },

  methods: {
    ...mapActions({
      getWhitelabel: `${moduleName}/getWhitelabel`,
    }),
    async init() {
      await this.getWhitelabel();
    },
    format(jenisId) {
      const firstPart = jenisId.substring(0, 1).toUpperCase();
      const lowerFirst = jenisId.substring(1, 5).toLowerCase();
      const secondPart = jenisId.substring(5, 6).toUpperCase();
      const lowerSecond = jenisId.substring(6, 9).toLowerCase();
      const number = jenisId.substring(9, 10);

      return `${firstPart}${lowerFirst} ${secondPart}${lowerSecond} ${number}`;
    },
  },
};
</script>

<style scoped>
.card {
  margin-bottom: 20px;
  border-radius: 10px;
}
.card-header {
  color: white;
  background-color: #206cff;
  width: 100%;
  height: auto;
  border-radius: 10px 10px 0px 0px;
}

.card-body {
  border-radius: 0px 0px 10px 10px;
}

.label {
  background-color: #f2924c;
  padding: 3px 4px 0px 4px;
  width: fit-content;
  border-radius: 3px;
  color: #fff;
  font-weight: 600;
}

/* @media screen and (min-width: 800px) and (max-width: 1199px) {
  .pemesananApp .card {
    float: left !important;
    width: calc(50% - 15px) !important;
  }
  .pemesananApp .card:nth-child(even) {
    margin-left: 15px !important;
  }
  .pemesananApp .card:nth-child(odd) {
    margin-right: 15px !important;
  }
} */

/* @media screen and (min-width: 1200px) {
  .pemesananApp .card {
    float: left !important;
    width: calc(25% - 15px) !important;
  }
  .pemesananApp .card {
    margin-left: 15px !important;
  }
  .pemesananApp .card:first-child {
    margin-left: 0px !important;
  }
} */

.pemesananApp .header-text {
  font-size: 16px !important;
}

.pemesananApp .price-text {
  font-size: 22px !important;
}

.pemesananApp .card-body .list-text {
  font-size: 14px !important;
}
</style>
